import { createSelectorPathBuilder } from '@/checkout-instore-legacy/utils/selectorHelper'

export const transferDataSelector = createSelectorPathBuilder([
  (state: any): any => state?.transfer,
])

export const transactionOrderGroupIdSelector = createSelectorPathBuilder([
  (state: any): string => state?.transfer?.orderGroupId,
])

export const transferCodeSelector = createSelectorPathBuilder([
  (state: any): string => state?.transfer?.code,
])
